/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon24Regular = forwardRef('FlagAIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 23a.75.75 0 0 0 1.5 0v-6.25h16.735c1.037 0 1.623-1.19.99-2.012L17.446 9.5l4.03-5.238c.632-.822.046-2.012-.991-2.012H4.5A2.25 2.25 0 0 0 2.25 4.5V23ZM4.5 3.75a.75.75 0 0 0-.75.75v10.75h16.227l-4.072-5.293a.75.75 0 0 1 0-.914l4.072-5.293H4.5Z" })));
});
